import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { styled } from "@mui/material/styles";
import Collapse from "@mui/material/Collapse";
import ComponentWrapper from "../ComponentWrapper/ComponentWrapper.js";
import Text from "../Text/Text.js";
import TextBlock from "../TextBlock/TextBlock.js";
import { useState } from "react";
import Button from "@mui/material/Button";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
const isTitleSlot = slot => typeof slot === "object" && slot !== null && "text" in slot;
const Template = styled("div"
// {
//   shouldForwardProp,
// },
)(({
  theme
}) => ({
  padding: theme.sizes.spacing.none,
  display: "flex",
  flexDirection: "column",
  gap: theme.sizes.spacing.none,
  flex: "1 0 0",
  alignSelf: "stretch",
  overflow: "hidden",
  ".card-container &": {
    height: `${2 * theme.sizes.grid.height}rem`
  },
  "& .card-header": {
    padding: `${theme.sizes.spacing["07"]} ${theme.sizes.spacing["08"]}`,
    backgroundColor: theme.colors.surface.primary,
    // height: theme.fonts.lineHeight['leading-10'],
    borderBottom: `1px solid ${theme.colors.border.primary}`,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    alignSelf: "stretch",
    gap: theme.sizes.spacing["06"],
    "& .MuiTypography-h5": {
      color: theme.colors.text.secondary
    }
  },
  "& .text-block-wrapper": {
    padding: theme.sizes.spacing["08"]
  }
}));
const TextBlockTemplate = t0 => {
  const $ = c(13);
  const {
    title,
    textBlock,
    helpContent,
    collapsible: t1
  } = t0;
  const collapsible = t1 === void 0 ? false : t1;
  const [isExpanded, setIsExpanded] = useState(false);
  let t2;
  if ($[0] !== collapsible || $[1] !== helpContent || $[2] !== isExpanded || $[3] !== title) {
    t2 = isTitleSlot(title) && /* @__PURE__ */jsxs(ComponentWrapper, {
      className: "card-header",
      children: [/* @__PURE__ */jsx(Text, {
        text: title.text,
        help: title.help || null,
        helpContent,
        variant: "h5",
        isMarkdown: title.isMarkdown
      }), collapsible && /* @__PURE__ */jsx(Button, {
        variant: "text",
        size: "small",
        onClick: () => setIsExpanded(!isExpanded),
        "aria-label": isExpanded ? "Hide" : "Show",
        "aria-expanded": isExpanded,
        sx: _temp,
        children: /* @__PURE__ */jsxs(Fragment, {
          children: [isExpanded ? "Hide" : "Show", isExpanded ? /* @__PURE__ */jsx(ExpandLess, {}) : /* @__PURE__ */jsx(ExpandMore, {})]
        })
      })]
    }, "title");
    $[0] = collapsible;
    $[1] = helpContent;
    $[2] = isExpanded;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = isExpanded || !collapsible;
  let t4;
  if ($[5] !== textBlock) {
    t4 = /* @__PURE__ */jsx(ComponentWrapper, {
      className: "text-block-wrapper",
      children: /* @__PURE__ */jsx(TextBlock, {
        text: textBlock
      })
    }, "text-block");
    $[5] = textBlock;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = /* @__PURE__ */jsx(Collapse, {
      in: t3,
      timeout: "auto",
      unmountOnExit: true,
      children: t4
    });
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = /* @__PURE__ */jsxs(Template, {
      children: [t2, t5]
    });
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
function _temp(theme) {
  return {
    padding: `${theme.sizes.spacing["02"]} ${theme.sizes.spacing["04"]}`,
    height: "min-content"
  };
}
export { TextBlockTemplate as default };